import { ArrowRight } from "lucide-react";
import { NavLink } from "react-router-dom";
import ActionButton from "../../workspace/components/atoms/actionButton";

type HomeTextActionProps = {
    children: string;
    to?: string;
    onClick?: () => void;
};

const linkClassName = "d-inline-flex align-items-center gap-1 text-decoration-none !k-text-primary";

const HomeTextAction = ({ children, to, onClick }: HomeTextActionProps) => {
    if (to) {
        return (
            <NavLink to={to} className={linkClassName}>
                {children}
                <ArrowRight size={14} strokeWidth={2} />
            </NavLink>
        );
    }

    return (
        <ActionButton
            variant="tertiary"
            type="button"
            className="px-2 py-1 fw-medium fs-8 !k-text-primary shadow-none bg-action-tertiary-hover"
            endIcon={<ArrowRight size={14} strokeWidth={2} />}
            onClick={onClick}
        >
            {children}
        </ActionButton>
    );
};

export default HomeTextAction;
